export const EDITOR_MODAL_CLASSES = {
  paper: 'w-full m-0 max-w-none max-h-screen min-h-full',
};
